import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

const Contact = () => {
    return (
        <div className="min-h-screen flex flex-col items-center justify-center bg-gradient-to-br from-indigo-600 via-purple-700 to-indigo-900 text-white px-4 text-center">
            <h1 className="text-4xl md:text-5xl font-bold mb-4 drop-shadow">
                Content Coming Soon
            </h1>
            <p className="text-lg md:text-xl mb-8 text-indigo-100 max-w-xl">
                We’re putting the finishing touches on this page. Check back soon to see what’s new!
            </p>
            <Link
                to="/"
                className="inline-flex items-center px-6 py-3 bg-white text-indigo-700 font-semibold rounded-lg shadow hover:bg-indigo-100 transition"
            >
                <ArrowLeft className="w-5 h-5 mr-2" />
                Return Home
            </Link>
        </div>
    );
};

export default Contact;